import { render, staticRenderFns } from "./TheSpaceAssignRolesDialog.vue?vue&type=template&id=128bb5f4&scoped=true&"
import script from "./TheSpaceAssignRolesDialog.vue?vue&type=script&lang=js&"
export * from "./TheSpaceAssignRolesDialog.vue?vue&type=script&lang=js&"
import style0 from "./TheSpaceAssignRolesDialog.vue?vue&type=style&index=0&id=128bb5f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128bb5f4",
  null
  
)

export default component.exports